<template>
  <div class="left_block store users">
    <p class="header">База знаний</p>

    <StoreFilter
      @submit="loadData"
      @delete="deleteChecked"
      @open-modal="openStoreAddModal"
      :rows="rows"
      :search="search"
    />

    <StoreTable
      @init-sort="initSort"
      @delete="deleteFile"
      :is-loading="isLoading"
      :rows="rows"
      :files-list="storageList"
    />

    <b-modal :active.sync="storeAddModal" has-modal-card scroll="keep">
      <StoreAdd :files="files" @upload="fileUploaded" @close-modal="closeStoreAddModal" />
    </b-modal>
  </div>
</template>

<script>
import StoreFilter from '@/components/admin/store/StoreFilter'
import StoreTable from '@/components/admin/store/StoreTable'
import StoreAdd from '@/components/admin/store/StoreAdd'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    StoreFilter,
    StoreTable,
    StoreAdd
  },
  data() {
    return {
      search: {
        name: '',
        sort: 'name',
        sort_type: 'desc'
      },
      rows: {
        checked: []
      },
      files: [],
      storeAddModal: false,
      isLoading: true
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    storageList() {
      return this.$store.state.storage.storageList
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('kb?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setStorageList', { list: resp.data.data })
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    openStoreAddModal() {
      this.storeAddModal = true
    },
    closeStoreAddModal() {
      this.storeAddModal = false
    },
    fileUploaded() {
      this.files.forEach((file) => {
        if (!file.type.includes('application')) {
          this.$buefy.toast.open(toastDanger('Тип файла не поддерживается'))
          return
        }
        const fData = new FormData()
        fData.append('file', file)
        fData.append('name', file.name)
        this.$axios2
          .post('kb', fData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.closeStoreAddModal()
            this.loadData()
            this.$buefy.toast.open(toastInfo())
          })
          .catch(this.$errorToast)
      })
      this.files = []
    },
    deleteFile(file) {
      this.$axios2
        .delete('kb/' + file.id)
        .then(() => {
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.deleteFile(this.rows.checked[i])
      }
      this.rows.checked = []
    }
  }
}
</script>
